import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeftIcon, ArrowRightIcon } from '@repo/icons';
import classNames from 'classnames';
import { useState } from 'react';
import { getLabels } from '../labels';
const MONTHS_IN_YEAR = 12;
export default function MonthSelector({ date = new Date(), disablePast, minDate, maxDate, testId, onMonthSelected, }) {
    const { monthLabels } = getLabels().calendar;
    const [year, setYear] = useState(date.getFullYear());
    const month = date.getMonth();
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const maxYear = maxDate.getFullYear();
    const maxMonth = maxDate.getMonth();
    const minYear = minDate?.getFullYear();
    const minMonth = minDate?.getMonth();
    const lowerBoundYear = Math.max(disablePast ? currentYear : -Infinity, minYear ?? -Infinity);
    const canGoNext = year < maxYear;
    const canGoPrev = year > lowerBoundYear;
    const isMonthChoosable = (monthIndex) => {
        if (disablePast) {
            const isFutureYear = year > currentYear;
            const isThisYearButFutureMonth = year === currentYear && monthIndex >= currentMonth;
            if (!(isFutureYear || isThisYearButFutureMonth))
                return false;
        }
        if (minYear !== undefined && minMonth !== undefined) {
            const isBeforeMinYear = year < minYear;
            const isMinYearButBeforeMinMonth = year === minYear && monthIndex < minMonth;
            if (isBeforeMinYear || isMinYearButBeforeMinMonth)
                return false;
        }
        const isAfterMaxYear = year > maxYear;
        const isMaxYearButAfterMaxMonth = year === maxYear && monthIndex > maxMonth;
        if (isAfterMaxYear || isMaxYearButAfterMaxMonth)
            return false;
        return true;
    };
    const handlePrevYear = () => {
        if (canGoPrev)
            setYear((currentValue) => currentValue - 1);
    };
    const handleNextYear = () => {
        if (canGoNext)
            setYear((currentValue) => currentValue + 1);
    };
    const handleMonthSelection = (monthIndex) => {
        if (!isMonthChoosable(monthIndex))
            return;
        const newDate = new Date(year, monthIndex, date.getDate());
        newDate.setHours(0, 0, 0, 0);
        onMonthSelected(newDate);
    };
    return (_jsxs("div", { className: "bg-primary-medium border-primary-medium flex w-fit flex-col gap-4 rounded-xl border p-5 shadow-lg", children: [_jsxs("div", { className: "text-heading flex w-60 justify-between", children: [_jsx("button", { className: canGoPrev ? 'cursor-pointer' : 'cursor-not-allowed opacity-40', onClick: handlePrevYear, disabled: !canGoPrev, "data-testid": testId.append('previous'), children: _jsx(ArrowLeftIcon, {}) }), _jsx("div", { className: "flex grow items-center justify-center gap-1 text-sm", children: _jsx("div", { className: "font-semibold", children: year }) }), _jsx("button", { className: canGoNext ? 'cursor-pointer' : 'cursor-not-allowed opacity-40', onClick: handleNextYear, disabled: !canGoNext, "data-testid": testId.append('next'), children: _jsx(ArrowRightIcon, {}) })] }), _jsx("div", { className: "text-body grid w-60 grid-cols-3 gap-1.5 text-center text-xs [&>button]:rounded-lg [&>button]:p-2", "data-testid": testId.append('months'), children: Array.from({ length: MONTHS_IN_YEAR }, (_, monthIndex) => {
                    const handleClick = () => handleMonthSelection(monthIndex);
                    const choosable = isMonthChoosable(monthIndex);
                    return (_jsx("button", { onClick: handleClick, disabled: !choosable, className: classNames(month === monthIndex ? 'bg-brand hover:bg-brand-strong text-white' : 'hover:bg-secondary', choosable ? 'cursor-pointer' : 'cursor-not-allowed opacity-40'), "data-testid": testId.append('months').append(monthIndex.toString()), children: monthLabels[monthIndex] }, monthIndex));
                }) })] }));
}
